const contactUs = {
  formTitle: '联系我们',
  submit: '发送',
  mail: '电子邮件',
  name: '名称',
  comment: '消息',
  sendText: '感谢您与我们联系!',
  toForm: '返回至上一步'
}
export default contactUs;